// extracted by mini-css-extract-plugin
export default {"option":"RoomDetailOption_option__ai7-h","option__item--unchecked":"RoomDetailOption_option__item--unchecked__z6Pxl"};